<template>
  <div class="view-pg oopt-view">
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ oopt.transName }}</h1>
      <div class="view-head">
        <v-tabs
          left
        >
          <v-tab>{{ $t('Основные сведения') }}</v-tab>
          <v-tab>{{ $t('Структура ООПТ') }}</v-tab>
          <v-tab>{{ $t('География') }}</v-tab>
          <v-tab v-if="oopt.transCharacteristicFlora || oopt.transCharacteristicFauna">{{ $t('Биоразнообразие') }}</v-tab>
          <v-tab v-if="objects.length > 0">{{ $t('Объекты') }}</v-tab>
          <v-tab v-if="documentsTourism.length > 0">{{ $t('Туризм') }}</v-tab>
          <v-tab v-if="oopt.transInterCooperation">{{ $t('Межд. сотр-во') }}</v-tab>
          <v-tab v-if="documents.length > 0">{{ $t('Документы') }}</v-tab>
<!--          <v-tab>{{ $t('НИ работы') }}</v-tab>-->
          <v-tab-item>
            <div class="view-description">
              <div class="view-main-info">
                <!-- Паспорт ООПТ -->
                <div class="main-info-item">
                  <h5>{{ $t('Паспорт ООПТ') }}</h5>
                  <p>
                    {{ $t('Наименование юридического лица') }}:
                    <span v-if="oopt.transLegalEntityName">{{ oopt.transLegalEntityName }}</span>
                    <span v-else>{{ $t('Нет сведений') }}</span>
                  </p>
                  <p>
                    {{ $t('Категория') }}:
                    <template v-if="oopt.category">
                      <span>{{ oopt.category.transName }}</span>
                    </template>
                  </p>
                  <p>
                    {{ $t('Категория МСОП') }}:
                    <template v-if="oopt.categoryIUCN">
                      <span>{{ oopt.categoryIUCN.transName }}</span>
                    </template>
                  </p>
                  <p>
                    {{ $t('Сведения о статусе') }}:
                    <label>
                      {{ $t('Национальный статус') }}
                      (<template v-if="oopt.npaNationalStatus">
                        <span>{{ oopt.npaNationalStatus.transName }}</span>
                      </template>
                      <span v-else>{{ $t('Нет сведений') }}</span>)
                    </label>
                    <label>
                      {{ $t('Международный статус') }}
                      (<span v-if="oopt.NpaInternationalStatus">{{ oopt.NpaInternationalStatus.transName }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>)
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('ИНН') }}:
                      <span v-if="oopt.inn">{{ oopt.inn }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                    <label>
                      {{ $t('ОКПО') }}:
                      <span v-if="oopt.okpo">{{ oopt.okpo }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Месторасположение') }}:
                      <template v-if="oopt.soateTerritories">
                        <span v-for="item in oopt.soateTerritories" :key="item.id">
                          {{ item.transName }}
                        </span>
                      </template>
                    </label>
                    <!--                    <label>-->
                    <!--                      <div v-html="oopt.transGeoLocation"></div>-->
                    <!--                    </label>-->
                  </p>
                  <p>
                    <label>
                      {{ $t('Трансграничное взаимодействие') }}:
                      <label v-if="oopt.crossBorderInteractions">
                          <template v-if="oopt.crossBorderInteractions.length > 0">
                            <span v-for="item in oopt.crossBorderInteractions" :key="item.id">
                              {{ item.transName }}
                            </span>
                          </template>
                          <template v-else>
                            {{ $t('Нет сведений') }}
                          </template>
                      </label>
                    </label>
                  </p>
                  <p>
                    {{ $t('Дата создания') }}:
                    {{ new Date(oopt.createdDate) | dateFormat('DD.MM.YYYY')}}
                  </p>
                  <p>
                    {{ $t('Реквизиты НПА') }}:
                    <template v-if="oopt.npaCreating">
                      <span>{{ oopt.npaCreating.transName }}</span>
                    </template>
                  </p>
                  <p>
                    <label>
                      {{ $t('Площадь') }}:
                      <span v-if="oopt.totalAreaOopt">{{ oopt.totalAreaOopt }} {{ $t('га') }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                    <label>
                      {{ $t('Площадь лесного фонда') }}:
                      <span v-if="oopt.forestArea">{{ oopt.forestArea }} {{ $t('га') }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                    <label>
                      {{ $t('Площадь водно-болотистых угодий') }}:
                      <span v-if="oopt.wetlandArea">{{ oopt.wetlandArea }} {{ $t('га') }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                    <label>
                      {{ $t('Площадь земельных участков') }}:
                      <span v-if="oopt.landArea">{{ oopt.landArea }} {{ $t('га') }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Ведомственная подчиненность') }}:
                      <span v-if="oopt.transDepartmentalSubordination">{{ oopt.transDepartmentalSubordination }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('ФИО руководителя') }}:
                      <span v-if="oopt.transHeadFullName">{{ oopt.transHeadFullName }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Должность руководителя') }}:
                      <span v-if="oopt.transHeadPosition">{{ oopt.transHeadPosition }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Юридический адрес') }}:
                      <span>
                        <template v-if="oopt.locality">{{ oopt.locality.treeFullTransName }}, </template>
                        <template>{{ oopt.transLegalAddress }}</template>
                      </span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Телефон') }}:
                      <span v-if="oopt.phones">{{ oopt.phones }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      Email:
                      <span v-if="oopt.email"><a v-bind:href="'mailto:' + oopt.email">{{ oopt.email }}</a></span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Принадлежность к группе') }}:
                      <span v-if="oopt.group">{{ oopt.group.transName }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p></p>
                </div>
                <!-- Цели и задачи -->
                <div class="main-info-item">
                  <h5>{{ $t('Цели и задачи') }}:</h5>
                  <div v-if="oopt.transTargetTaskOopt" v-html="oopt.transTargetTaskOopt"></div>
                  <div v-else>{{ $t('Нет сведений') }}</div>
                </div>
                <div class="main-info-item" v-if="npas.length > 0">
                  <h5>{{ $t('Нормативная основа функционирования ООПТ') }}</h5>
                  <ul>
                    <li v-for="(npa) in npas" :key="npa.id">
                      <template v-if="npa.link">
                        <a :href="npa.link" target="_blank">
                          {{ npa.transName }} № {{ npa.npa_number }} {{ $t('от')}} {{ new Date(npa.adoption_date) |
                          dateFormat('DD.MM.YYYY')}}
                        </a>
                      </template>
                      <template v-else>
                        {{ npa.transName }} № {{ npa.npa_number }} {{ $t('от')}} {{ new Date(npa.adoption_date) |
                        dateFormat('DD.MM.YYYY')}}
                      </template>
                    </li>
                  </ul>
                </div>
                <div class="main-info-item">
                  <h5>{{ $t('Описание') }}</h5>
                  <div v-if="!showMore" v-html="oopt.transGeoLocation"></div>
                  <div v-if="showMore">
                    <div v-html="oopt.transDescription"></div>
                  </div>
                  <p v-if="oopt.transGeoLocation || oopt.transDescription">
                    <a @click.prevent="showMore = !showMore" href="#"
                       class="read-more">{{ showMore ? $t('Скрыть') : $t('Подробнее') }}</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="view-body">
              <template v-if="mapBlock">
                <MapOpenLayers :ooptId="oopt.id"/>
              </template>
              <div class="carousel-wrap bgw-pdg-20" v-if="galleryImages.length">
                <Carousel :items="galleryImages"/>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="structure-oopt">
              <div class="main-info-item">
                <div class="flexbox">
                  <div>
                    <p>
                      {{ $t('Площадь') }}:
                      <span v-if="oopt.totalAreaOopt">{{ oopt.totalAreaOopt }} {{ $t('га') }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </p>
                  </div>
                </div>
                <h3>{{ $t('Зоны') }}</h3>
                <div v-for="zone in zones" :key="zone.id">
                  <p>
                    <strong>{{ zone.zoneType }}</strong> {{ zone.area }} {{$t('га')}} {{ zone.specificWeight }}% от общей площади
                  </p>
                  <div v-for="area in zone.areas" :key="area.id">
                    <p>
                      {{ area.transName }}:
                      <span v-for="quarter in area.quarters" :key="quarter.id">{{ $t('Кварталы') }} {{ quarter.number }}
                        <span v-for="zoneSelection in quarter.zoneSelections" :key="zoneSelection.id">{{ $t('Выделы') }} {{ zoneSelection.transName }}
                          <span v-for="highlight in zoneSelection.highlights" :key="highlight.id">{{ highlight.number }}, </span>
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <p v-if="oopt.npaZoning">{{ oopt.npaZoning.transName }}</p>
              </div>
              <div class="main-info-item">
                <h5>{{ $t('Участки') }}</h5>
                <div class="table-overflow">
                  <table class="table-full">
                    <thead>
                    <tr>
                      <td class="num-td">№</td>
                      <td class="full-name-td">{{ $t('Название участка') }}</td>
                      <td class="full-name-td">{{ $t('Тип участка') }}</td>
                      <td class="full-name-td">{{ $t('Номер') }}</td>
                      <td class="full-name-td">{{ $t('Площадь') }}</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(plot, i) in areas" :key="plot.id">
                      <td class="num-td">{{ ++i }}</td>
                      <td class="full-name-td">
                        {{ plot.transName }}
                      </td>
                      <td class="full-name-td">
                        {{ plot.plotType }}
                      </td>
                      <td class="full-name-td">
                        {{ plot.number }}
                      </td>
                      <td class="full-name-td">
                        {{ plot.square }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <template v-if="oopt.transViolationTerritory">
              <h4>{{ $t('Нарушенность территории') }}</h4>
              <div v-html="oopt.transViolationTerritory"></div>
            </template>
            <template v-if="oopt.transRelief">
              <h4>{{ $t('Рельеф') }}</h4>
              <div v-html="oopt.transRelief"></div>
            </template>
            <template v-if="oopt.transClimate">
              <h4>{{ $t('Климат') }}</h4>
              <div v-html="oopt.transClimate"></div>
            </template>
            <template v-if="oopt.transBriefDescrSoilCover">
              <h4>{{ $t('Краткая характеристика почвенного покрова') }}</h4>
              <div v-html="oopt.transBriefDescrSoilCover"></div>
            </template>
            <template v-if="oopt.transDescHydrologicalNet">
              <h4>{{ $t('Описание гидрологической сети') }}</h4>
              <div v-html="oopt.transDescHydrologicalNet"></div>
            </template>
            <template v-if="oopt.transForestInfo">
              <h4>{{ $t('Сведения о лесных ресурсах') }}</h4>
              <div v-html="oopt.transForestInfo"></div>
            </template>
            <template v-if="oopt.transMajorEcoSystemCharacter">
              <h4>{{ $t('Характеристика основных экосистем ООПТ') }}</h4>
              <div v-html="oopt.transMajorEcoSystemCharacter"></div>
            </template>
            <template v-if="oopt.transNaturalRecreationalResources">
              <h4>{{ $t('Природные лечебные и рекреационные ресурсы') }}</h4>
              <div v-html="oopt.transNaturalRecreationalResources"></div>
            </template>
            <template v-if="oopt.transNegImpactFactor">
              <h4>{{ $t('Факторы негативного воздействия') }}</h4>
              <div v-html="oopt.transNegImpactFactor"></div>
            </template>
            <template v-if="oopt.transNegImpactThreat">
              <h4>{{ $t('Угрозы негативного воздействия') }}</h4>
              <div v-html="oopt.transNegImpactThreat"></div>
            </template>
            <template v-if="oopt.transAssessmentCurrentState">
              <h4>{{ $t('Оценка современного состояния и вклада ООПТ в поддержании экологического баланса окружающих территорий') }}</h4>
              <div v-html="oopt.transAssessmentCurrentState"></div>
            </template>
          </v-tab-item>
          <v-tab-item v-if="oopt.transCharacteristicFlora || oopt.transCharacteristicFauna">
            <template v-if="oopt.transCharacteristicFlora">
              <h4>{{ $t('Характеристика флоры и растительности') }}</h4>
              <div v-html="oopt.transCharacteristicFlora"></div>
            </template>
            <template v-if="oopt.transCharacteristicFauna">
              <h4>{{ $t('Сведения о животном мире') }}</h4>
              <div v-html="oopt.transCharacteristicFauna"></div>
            </template>
          </v-tab-item>
          <v-tab-item v-if="objects.length > 0">
            <div class="view-description">
              <div v-for="ooptObject in objects" :key="ooptObject.id" class="oopt-object">
                <h5>
                  {{ $t('Наименование объекта') }}: <span>{{ ooptObject.transName }}</span>
                </h5>
                <p>
                  {{ $t('Краткое описание') }}: <span>{{ ooptObject.description }}</span>
                </p>
                <table class="table-full">
                  <tbody>
                    <tr>
                      <td class="td-name">{{ $t('Категория') }}</td>
                      <td>{{ ooptObject.category }}</td>
                    </tr>
                    <tr>
                      <td class="td-name">{{ $t('Общая функциональная площадь, га') }}</td>
                      <td>{{ ooptObject.totalAreaSquare }}</td>
                    </tr>
                    <tr>
                      <td class="td-name">{{ $t('Сведения о владельце') }}</td>
                      <td>{{ ooptObject.headFullName }}</td>
                    </tr>
                    <tr>
                      <td class="td-name">{{ $t('Режим функционирования') }}</td>
                      <td>{{ ooptObject.functioningMode }}</td>
                    </tr>
                    <tr>
                      <td class="td-name">{{ $t('Среднегодовой поток посетителей') }}</td>
                      <td>{{ ooptObject.averageAnnualFlowVisitors }}</td>
                    </tr>
                    <tr>
                      <td class="td-name">{{ $t('Максимальная емкость') }}</td>
                      <td>{{ ooptObject.maxCapacity }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="carousel-wrap bgw-pdg-20" v-if="ooptObject.galleries.length">
                  <Carousel :items="ooptObject.galleries"/>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="documentsTourism.length > 0">
            <h4>{{ $t('Туризм') }}</h4>
            <div class="table-overflow">
              <table class="table-full">
                <thead>
                <tr>
                  <td class="num-td">№</td>
                  <td class="full-name-td">{{ $t('Наименование') }}</td>
                  <td class="full-name-td">{{ $t('Тип') }}</td>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="(documentTourism, i) in documentsTourism" :key="documentTourism.id">
                    <td class="num-td">{{ ++i }}</td>
                    <td class="full-name-td">
                      <a :href="backUrl + documentTourism.file" target="_blank">{{ documentTourism.transName }}</a>
                    </td>
                    <td class="full-name-td">{{ documentTourism.type }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab-item>
          <v-tab-item v-if="oopt.transInterCooperation">
            <h4>{{ $t('Международное сотрудничество') }}</h4>
            <div v-html="oopt.transInterCooperation"></div>
          </v-tab-item>
          <v-tab-item v-if="documents.length > 0">
            <h4>{{ $t('Документы') }}</h4>
            <div class="table-overflow">
              <table class="table-full">
                <thead>
                <tr>
                  <td class="num-td">№</td>
                  <td class="full-name-td">{{ $t('Наименование') }}</td>
                  <td class="full-name-td">{{ $t('Тип') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(document, i) in documents" :key="document.id">
                  <td class="num-td">{{ ++i }}</td>
                  <td class="full-name-td">
                    <a :href="backUrl + document.file" target="_blank">{{ document.transName }}</a>
                  </td>
                  <td class="full-name-td">{{ document.type }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-tab-item>
<!--          <v-tab-item>-->
<!--            <template>-->
<!--              <div class="research-work">-->
<!--                <v-treeview-->
<!--                  :items="catalogs"-->
<!--                  open-on-click-->
<!--                  transition-->
<!--                >-->
<!--                  <template v-slot:prepend="{ item, open }">-->
<!--                    <template v-if="item.file">-->
<!--                      <v-icon>-->
<!--                        mdi-file-document-outline-->
<!--                      </v-icon>-->
<!--                      <a :href="backUrl + item.file" target="_blank">{{ item.label }}</a>-->
<!--                    </template>-->
<!--                    <template v-else>-->
<!--                      <v-icon>-->
<!--                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}-->
<!--                      </v-icon>-->
<!--                      {{ item.label }}-->
<!--                    </template>-->
<!--                  </template>-->
<!--                </v-treeview>-->
<!--              </div>-->
<!--            </template>-->
<!--          </v-tab-item>-->
        </v-tabs>
      </div>
    </v-container>
  </div>
</template>
<script>
import Carousel from '@/components/app/Carousel'
import OOPT from '@/model/oopt'
import { mapMutations } from 'vuex'
import MapOpenLayers from '@/components/oopt/MapOpenLayers'

export default {
  components: {
    Carousel,
    MapOpenLayers
  },
  data: () => ({
    oopt: {},
    showMore: false,
    breadcrumbs: [],
    galleryImages: [],
    zones: [],
    npas: [],
    areas: [],
    objects: [],
    documents: [],
    documentsTourism: [],
    catalogs: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    mapBlock: false
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),

    // Данные ООПТ
    fetchData () {
      this.setLoading(true)
      OOPT.getOoptView(this.$route.params.id)
        .then((response) => {
          if (response.status === 400) {
            this.$router.push({
              name: 'Search'
            })
          }
          this.oopt = response.data.oopt
          this.galleries = response.data.galleries
          this.npas = response.data.npas
          this.zones = response.data.zones
          this.areas = response.data.areas
          this.objects = response.data.objects
          this.documents = response.data.documents
          this.documentsTourism = response.data.documentsTourism
          this.catalogs = response.data.catalogs

          this.galleries.forEach(gallery => {
            this.galleryImages.push({
              src: this.backUrl + gallery.fullFilesDirectory
            })
          })

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('ООПТ'),
              disabled: false,
              href: '/search'
            },
            {
              text: this.oopt.transName,
              disabled: true
            }
          ]
          this.mapBlock = true
          this.scrollToTop()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.$router.push({
            name: 'Search'
          })
        })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
